import React from "react";
import { Button, Card, Table } from "antd";
import PropTypes from "prop-types";
import LogTraceService from "../../services/LogTraceService";
import { catchError } from "../../services/DaoService";
import { ReloadOutlined } from "@ant-design/icons";

export default function LogTraces({ target, parentId }) {
    const [logTraces, setLogTraces] = React.useState([]);
    const [paginationData, setPaginationData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [hasMore, setHasMore] = React.useState(true);

    const fetchLogTraces = React.useCallback(() => {
        setLoading(true);
        setLogTraces([]);
        LogTraceService.getInstance()
            .findAll(target, parentId)
            .then((response) => {
                setPaginationData(response.data);
            }).catch((error) => {
                catchError(error);
            }).finally(() => {
                setLoading(false);
            });
    }, [target, parentId]);

    React.useEffect(() => {
        fetchLogTraces();
    }, [fetchLogTraces]);

    React.useEffect(() => {
        if (paginationData) {
            setLogTraces(logTraces => {
                return [...logTraces, ...paginationData.data.filter(logTrace => !logTraces.find(lt => lt.id === logTrace.id))];
            });
            setHasMore(paginationData.next_page_url !== null);
        } else {
            setLogTraces([]);
            setHasMore(false);
        }
    }, [paginationData]);

    const loadMore = () => {
        if (hasMore && !loading) {
            setLoading(true);
            LogTraceService
                .get(paginationData.next_page_url)
                .then((response) => {
                    setPaginationData(response.data);
                }).catch((error) => {
                    catchError(error);
                }).finally(() => {
                    setLoading(false);
                });
        }
    }

    
    const processLogData = (logTraces) => {
        let processedData = [];

        logTraces.forEach((logTrace) => {
            const changes = JSON.parse(logTrace.changes);
            Object.entries(changes).forEach(([field, { original, current }]) => {
                processedData.push({
                    id: logTrace.id,
                    name: field,
                    original: original,
                    current: current,
                    user: logTrace.user.email,
                    created_at: logTrace.created_at,
                });
                // supprimer les doublons
                processedData = processedData.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
            });
        });

        return processedData;
    };

    const columns = [
        {
            title: "No",
            dataIndex: "id",
            key: "id",
            render: (text, record, index) => index + 1,
            width: 100,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            fixed: 'left',
        },
        {
            title: 'Original',
            dataIndex: 'original',
            key: 'original',
            width: 200,
            ellipsis: true,
        },
        {
            title: 'Courrante',
            dataIndex: 'current',
            key: 'current',
            width: 200,
            ellipsis: true,
        },
        {
            title: "Utilisateur",
            dataIndex: "user",
            key: "user",
            width: 200,
        },
        {
            title: "Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (date) => new Date(date).toLocaleString(),
            width: 200,
        },
    ];


    const processedData = processLogData(logTraces);

    return (
        <Card actions={[
            <Button key={"loadMoreBtn"} type="primary" onClick={loadMore} disabled={!hasMore}>
                {hasMore ? "Charger plus" : "Fin de la liste"}
            </Button>
        ]} extra={
            <Button icon={<ReloadOutlined />} iconPosition="end" loading={loading} type="default" onClick={fetchLogTraces}>Rafraîchir</Button>
        }
        >
            <Table scroll={{
                x: 800,
                y: 500,
            }} loading={loading} pagination={false} columns={columns} dataSource={processedData} rowKey="uid" />
        </Card>
    );
}

LogTraces.propTypes = {
    target: PropTypes.string.isRequired,
    parentId: PropTypes.number.isRequired,
};
